/**
 * Timezone names that devices still report at signup but that we do not keep
 * as primary selectable country zones.
 *
 * Devices with older ICU data (older Android, stale tzdata) can report
 * pre-rename zone names. Browsers can also report detailed regional zones that
 * share future offset rules with a representative zone in COUNTRIES.zones. We
 * normalize incoming signup timezones through this map before validating
 * against COUNTRIES.zones, AND write the normalized value back onto the signup
 * payload so the location row is stored with an allowed zone.
 *
 * Only list aliases whose target already exists in a country's COUNTRIES.zones
 * list — otherwise normalization just shifts the "not in list" error.
 */
export const TIMEZONE_ALIASES: Readonly<Record<string, string>> = {
  'America/Juneau': 'America/Anchorage',
  'America/Sitka': 'America/Anchorage',
  'America/Metlakatla': 'America/Anchorage',
  'America/Yakutat': 'America/Anchorage',
  'America/Nome': 'America/Anchorage',
  'America/Kentucky/Monticello': 'America/Kentucky/Louisville',
  'America/Indiana/Winamac': 'America/Indiana/Indianapolis',
  'America/Indiana/Marengo': 'America/Indiana/Indianapolis',
  'America/Indiana/Petersburg': 'America/Indiana/Indianapolis',
  'America/Indiana/Vevay': 'America/Indiana/Indianapolis',
  'America/Indiana/Tell_City': 'America/Indiana/Knox',
  'America/Menominee': 'America/Chicago',
  'America/North_Dakota/Center': 'America/Chicago',
  'America/North_Dakota/New_Salem': 'America/Chicago',
  'America/North_Dakota/Beulah': 'America/Chicago',
  'America/Glace_Bay': 'America/Halifax',
  'America/Goose_Bay': 'America/Halifax',
  'America/Nipigon': 'America/Toronto',
  'America/Thunder_Bay': 'America/Toronto',
  'America/Iqaluit': 'America/Toronto',
  'America/Pangnirtung': 'America/Toronto',
  'America/Rainy_River': 'America/Winnipeg',
  'America/Resolute': 'America/Winnipeg',
  'America/Rankin_Inlet': 'America/Winnipeg',
  'America/Swift_Current': 'America/Regina',
  'America/Cambridge_Bay': 'America/Edmonton',
  'America/Yellowknife': 'America/Edmonton',
  'America/Inuvik': 'America/Edmonton',
  'America/Dawson_Creek': 'America/Creston',
  'America/Fort_Nelson': 'America/Creston',
  'America/Whitehorse': 'America/Creston',
  'America/Dawson': 'America/Creston',
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Macao': 'Asia/Macau',
  'Asia/Dacca': 'Asia/Dhaka',
  'Asia/Ashkhabad': 'Asia/Ashgabat',
  'Asia/Ulan_Bator': 'Asia/Ulaanbaatar',
  'Asia/Ujung_Pandang': 'Asia/Makassar',
  'Asia/Thimbu': 'Asia/Thimphu',
  'America/Indianapolis': 'America/Indiana/Indianapolis',
  'Europe/Kiev': 'Europe/Kyiv',
  'Europe/Uzhgorod': 'Europe/Kyiv',
  'Europe/Zaporozhye': 'Europe/Kyiv',
  'Europe/Nicosia': 'Asia/Nicosia',
  'America/Godthab': 'America/Nuuk',
  'Africa/Asmera': 'Africa/Nairobi',
  'Atlantic/Faeroe': 'Atlantic/Faroe',
  'Pacific/Ponape': 'Pacific/Pohnpei',
  'Pacific/Truk': 'Pacific/Chuuk',
  'Pacific/Samoa': 'Pacific/Pago_Pago',
};
